<template>
  <div id="pre-insc-old" class="d-flex align-center">
    <div class="bg"></div>
    <v-container fill-height>
      <v-row justify="center" align="center" class="my-4">
        <v-col cols="12" xl="5" md="6" class="mr-md-12">
          <div class="allcaps ml-2 mt-0 mb-12 mb-md-3 text-center text-md-left">
            <p><span class="underline px-1">Curso</span></p>
          </div>
          <div class="mt-8 text-center text-md-left">
            <h1 class="mb-4">Atualização do uso do Canabidiol e seus Derivados na Medicina e Esporte</h1>
            <p class="data-evento allcaps">Conteúdo: <span class="px-2 mx-2">7h de aulas</span></p>
          </div>
          <div class="py-4">
            <!-- <p>Vem aí o curso de Atualização do uso do Canabidiol e seus Derivados na Medicina e Esporte</p> -->
            <!-- <p>Nesta edição abordaremos tópicos sobre a utilização do Óleo de Canabidiol e derivados em diversas áreas da medicina. Confira aqui:</p> -->
            <p>Palestras sobre a utilização do Óleo de Canabidiol e seus derivados em diversos campos da medicina, com um time ESPETACULAR de palestrantes especialistas em suas áreas. Confira:</p>
            <ul class="my-4">
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps">Reumatologia</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps">Psiquiatria</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps">Geriatria</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps">Ortopedia</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps">Medicina Esportiva</span>
              </li>
            </ul>
            <!-- <p>E para não perder o costume, convidamos um time ESPETACULAR de palestrantes, especialistas em suas áreas para compartilharem suas experiências.</p> -->
            <!-- <p>Aproveite nosso lote promocional e garanta já sua vaga com DESCONTO!</p> -->
            <div class="curso-info my-8">
              <p class="allcaps mb-3">
                <span class="font-weight-bold mr-4">Investimento:</span> 
                <span class="btn-primary px-1">R$200</span>
              </p>
              <p class="allcaps">Acesso ilimitado por 12 meses</p>
            </div>
          </div>
          <!-- ORGANIZAÇÃO -->
          <div class="mt-12 d-none d-md-inline">
            <p class="overline text-center text-md-left">Organização</p>
            <v-row class="">
              <v-col
                v-for="(org, i) in orgs"
                :key="i"
                cols="12"
                md="3"
                class="mr-md-8 my-10 my-md-0"
              >
                <a
                  :href="org.href"
                  target="_blank"
                >
                  <v-img
                    :src="org.src"
                    alt=""
                    contain
                    class="orgs-img"
                    position="center"
                    :href="org.href"
                  ></v-img>
                </a>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" xl="4" md="5" class="px-0">
          <v-sheet
            class="btn-primary px-5 py-5 pb-0 rounded-r-xl pt-12"
            flat
          >
            <h3 class="text-center allcaps ml-2 mt-0 mb-3"><span class="white green--text px-1">Inscreva-se já!</span></h3>
            <p class="white--text mb-0 text-center">Preencha o formulário abaixo e faça a sua inscrição:</p>
            <div>
              <!-- <FormNews /> -->
              <FormMailchimp />
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row justify="center" class="py-12">
        <Quote />
      </v-row>
    </v-container>

    <!-- PROGRAMA -->
    <v-container>
      <v-row justify="center" class="mt-8 mb-4">
        <!-- <v-col cols="12" class="text-center">
          <h2>O que o curso irá abordar?</h2>
        </v-col> -->
        <v-col cols="12" md="11" xl="9" class="px-0">
          <h3 class="txt2 mb-8 text-center text-md-left"><span class="btn-primary px-1">Programa</span></h3>
          <v-expansion-panels class="programa">
            <v-expansion-panel
              v-for="(item,i) in programa"
              :key="i"
            >
              <v-expansion-panel-header class="txt-2 text-center">
                {{ item.title }}
                <template v-slot:actions>
                  <v-icon class="cc-primary--text">
                    $expand
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-4">
                <!-- <ul>
                  <li v-for="(palestra, i) in item.palestras" :key="i" class="palestra">
                    <v-icon color="green">mdi-square-small</v-icon>
                    {{ palestra.nome }}
                  </li>
                </ul> -->
                <div v-for="(palestra, i) in item.palestras" :key="i" class="palestra">
                  <p class="hora">{{ palestra.hora }}</p>
                  <p class="nome">{{ palestra.nome }}</p>
                  <p class="palestrante">{{ palestra.palestrante }}</p>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- PALESTRANTES -->
    <v-container>
      <v-row justify="center" class="my-4">
        <v-col cols="12" md="11" xl="9" class="px-0 text-center text-md-left">
          <h3><span class="txt2 alt-text">Palestrantes</span></h3>
        </v-col>
        <v-col cols="12" md="11" xl="9" class="px-8">
          <div class="palestrantes">
            <div
              v-for="(p, i) in palestrantes"
              :key="i"
              class="palestrante"
            >
              <div class="d-flex align-center">
                <div class="mr-4">
                  <!-- <v-avatar
                    size="70"
                  > -->
                  <div class="">
                    <img
                      :src="p.src"
                      class="p-img avatar"
                      :alt="p.nome"
                      :title="p.nome"
                      width="70px"
                      height="70px"
                    >
                  </div>
                  <!-- </v-avatar> -->
                </div>
                <div>
                  <p class="p-nome mb-1"><span class="underline mb-0 pb-0">{{ p.nome }}</span></p>
                  <p class="allcaps mb-0">{{ p.esp }}</p>
                </div>
              </div>
              <!-- <v-img
                :src="p.src"
                class="p-img"
                :alt="p.nome"
                :title="p.nome"
                width="80px"
                height="80px"
              ></v-img> -->
              <p>{{ p.info }}</p>
            </div>
          </div>
        </v-col>

      </v-row>
    </v-container>

    <v-container fluid id="como-funciona" class="pb-0">
      <v-row justify="center" class="">
        <v-col cols="12" class="cc-primary px-0 pt-12 pb-0 text-center">
          <h2 color="">Como funciona o curso</h2>
          <p color="">Veja quando e onde quiser!</p>
        </v-col>
        <v-container fluid class="py-0">
          <v-row class="d-flex vantagens cc-primary py-12 px-6 px-md-12">
            <v-col
              v-for="(v,i) in vantagens"
              :key="i"
              cols="12"
              md="3"
              xl="3"
              class="vantagem text-center px-6 py-4"
            >
              <div class="d-flex vant px-8 py-12">
                <v-icon color="green" class="mb-3" large>{{ v.icon }}</v-icon>
                <h4 class="mb-4">{{ v.title }}</h4>
                <p>{{ v.desc }}</p>
              </div>
            </v-col>
          </v-row>
          <v-row class="d-flex vantagens cc-primary py-12 px-md-12">
            <v-col cols="12" class="text-center">
              <h2 class="mb-12">
                <span class="py-1">
                  Tá esperando o que?
                </span>
              </h2>
              <div class="btn-primary--alt py-4 px-2 mx-auto" style="max-width: 500px">
                <a href="#pre-insc" class="allcaps btn-primary--alt px-2 py-1">
                  Faça já sua inscrição!
                </a>
              </div>
            </v-col>
            <!-- <v-col cols="12">
              <div>
                <FormBottom />
              </div>
            </v-col> -->
          </v-row>
        </v-container>
      </v-row>
    </v-container>
    <!-- <v-container>
      <v-row></v-row>
    </v-container> -->
    <FooterAlt />
  </div>
</template>

<script>
import FormNews from '@/components/forms/FormNews'
import FormBottom from '@/components/forms/FormNews'
import Quote from '@/components/layout/Quote'
import FooterAlt from '@/components/layout/FooterAlt'
import FormMailchimp from '@/components/forms/FormMailchimp'

export default {
  name: 'Pre-Inscricao-Old',
  components: {
    FormMailchimp,
    FormNews,
    FormBottom,
    Quote,
    FooterAlt,
  },
  data() {
    return {
      orgs: [
        {
          src: require('../assets/logoCMF.png'),
          href: 'https://centrofluminense.com.br/'
        },
        {
          src: require('../assets/logo-352-full.png'),
          href: 'https://agencia352.com/'
        },
        {
          src: require('../assets/logo-we4u.png'),
          href: 'https://we4u.com.br/'
        },
      ],
      programa: [
        {
          title: 'Bloco 1 - O Canabidiol e Seus Derivados',
          palestras: [
            {
              hora: '08h - 8:10h',
              nome: 'Abertura e apresentação dos palestrantes',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '08:10h - 8:30h',
              nome: 'História da Cannabis medicinal',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '8:30h - 09h',
              nome: 'Legislação e normas da Cannabis medicinal no Brasil',
              palestrante: 'Dra. Alessandra Soares'
            },
            {
              hora: '09h - 09:30h',
              nome: 'Sistema endocanabinoide',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '09:30h - 09:50h',
              nome: 'Fitocanabinoides: CBD, THC, Terpenos e Flavonoides',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '09:50h - 10h',
              nome: 'Perguntas e respostas',
              palestrante: ''
            },
            {
              hora: 'Intervalo de 15 minutos',
              nome: '',
              palestrante: ''
            },
          ]
        },
        {
          title: 'Bloco 2 - Indicações do Canabidiol',
          palestras: [
            {
              hora: '10:15h – 10:45h',
              nome: 'Aplicações Clínicas: Geriatria e Medicina paliativa',
              palestrante: 'Dr. Filipe Gusman'
            },
            {
              hora: '10:45h – 11:00h',
              nome: 'Aplicações Clínicas: Medicina do Esporte – Doping no Esporte',
              palestrante: 'Dr José Kawazoe'
            },
            {
              hora: '11:00h – 11:30h',
              nome: 'Aplicações Clínicas: Medicina do Esporte',
              palestrante: 'Dra Natalia Mourão/ Dr. Jimmy Fardin'
            },
            {
              hora: '11:30h – 12:00h',
              nome: 'Aplicações Clínicas: Lesões de atletas',
              palestrante: 'Diogo Souza'
            },
            {
              hora: 'Intervalo de 20 minutos',
              nome: '',
              palestrante: ''
            },
          ]
        },
        {
          title: 'Bloco 3 - Prescrições e casos clínicos do Canabidiol e seus derivados',
          palestras: [
            {
              hora: '12:20h – 12:50h',
              nome: 'Aplicações Clínicas : Psiquiatria',
              palestrante: 'Dr. Octavio Pavan'
            },
            {
              hora: '12:50h – 13:20h',
              nome: 'Aplicações Clínicas : Reumatologia',
              palestrante: 'Dra. Selma Merenlender'
            },
            {
              hora: '13:20h – 14:00h',
              nome: 'Casos Clínicos, regras para prescrição e Fechamento',
              palestrante: 'Dra. Selma Merenlender'
            },
          ]
        },

      ],
      palestrantes: [
        {
          id: 'selma',
          nome: 'Dra. Selma Merenlender',
          esp: 'Reumatologista',
          info: 'Ex-Presidente da Sociedade de Reumatologia do Rio de Janeiro; Diretora Técnica do Centro Multidisciplinar Fluminense. Além de um dos grandes nomes da Reumatologia do Brasil, a Dra Selma Merenlender possui vasta experiência no uso de Cannabis Medicinal no Tratamento de Doenças Reumatológicas.',
          src: require('../assets/selma.png'),
        },
        {
          id: 'octavio',
          nome: 'Dr. Octávio Pavan',
          esp: 'Psiquiatra',
          info: 'O Dr. Octávio Pavan é médico psiquiatra por formação e possui vasta experiência com o  Uso de Canabis Medicinal no tratamento de doenças psiquiátricas como Depressão e Ansiedade.',
          src: require('../assets/octavio.png'),
        },
        {
          id: 'filipe',
          nome: 'Dr. Filipe Gusman',
          esp: 'Geriatra e Cuidados paliativos',
          info: 'O Dr Felipe Gusman é geriatra pela SBGG, Fundador e atual presidente da Academia Nacional de Cuidados Paliativos – Seccional Rio de Janeiro. Membro da Câmara técnica de Medicina Paliativa do CREMERJ. Possui grande experiência com o uso de Cannabis medicinal.',
          src: require('../assets/filipe.png'),
        },
        {
          id: 'natalia',
          nome: 'Dra. Natalia Mourão',
          esp: 'Ortopedista e Médica do Esporte',
          info: 'A Dra Natalia Mourão é Ortopedista e Traumatologista titulada pela SBOT, Médica do Esporte titulada pela SBMEE, Médica da Confederação Brasileira de Taekwondo, Vice presidente da Associação de Mulheres Ortopedistas do Brasil (AMOB).',
          src: require('../assets/natalia.png'),
        },
        {
          id: 'diogo',
          nome: 'Diogo Souza',
          esp: 'Preparador Físico de Alto Rendimento',
          info: 'Diogo Souza é formado em Educação Física e Pós Graduado em Exercícios Físico a Reabilitação Cardíaca e a Grupos Especiais. Com uma enorme  experiência em preparação física em alto rendimento onde até hoje  atua no condicionamento físico de atletas como Rogério Minotouro (UFC) ; José Mario Sperry(PRIDE); Toquinho (Ex-UFC), o  preparador físico divide seu tempo entre sua escola de excelência de preparação Física, Ludus Actius,  e no condicionamento físico de atletas de luta de alto rendimento. ',
          src: require('../assets/diogo.png'),
        },
        {
          id: 'kawazoe',
          nome: 'Dr. José Kawazoe',
          esp: 'Médico do Exercício e do Esporte',
          info: 'Especialista em Cardiologia e em Medicina do Exercício e do Esporte. Professor Adjunto do Instituto Biomédico da Universidade Federal Fluminense. Ex-Presidente da Sociedade Brasileira de Medicina do Exercício e do Esporte - SBMEE (2009/2011). Presidente da Confederação Panamericana de Medicina do Esporte - COPAMEDE. Tesoureiro da Federação Internacional de Medicina do Esporte - FIMS. Presidente da Comissão de Autorização para Uso Terapêutico (CAUT) da Autoridade Brasileira de Controle de Dopagem (ABCD)',
          src: require('../assets/kawazoe.png'),
        },
        {
          id: 'jimmy',
          nome: 'Dr. Jimmy Fardin',
          esp: 'Ortopedista e Traumatologista',
          info: 'Dr Jimmy Fardin ortopedista e traumatologista, cirurgião de joelho e especialista em cannabis medicinal desde 2018',
          src: require('../assets/jimmy.png'),
        },
      ],
      vantagens: [
        {
          icon: 'fas fa-globe',
          title: '100% Online',
          desc: 'Nosso curso é 100% Online, com toda a comodidade e conforto desse formato.'
        },
        {
          icon: 'fas fa-unlock',
          title: '12 meses de acesso liberado',
          desc: 'Está ocupado no dia? Não tem problema, você tem até 1 ano para acessar.'
        },
        {
          icon: 'fas fa-play',
          title: 'Veja e reveja',
          desc: 'Durante um ano você terá acesso liberado para você ver e rever quantas vezes quiser.'
        },
        {
          icon: 'fas fa-question',
          title: 'Pintou dúvida?',
          desc: 'Além de poder tirar suas dúvidas via email, você fará parte de um grupo de debates com os palestrantes.'
        },
      ],
    }
  },
  mounted() {
    this.$vuetify.theme.dark = false
  }
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

#pre-insc-old {
  padding-top: 30px;
  min-height: 100vh;
  flex-direction: column;

  @include xs {
    // text-align: center;
  }
  // .bg {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   background-image: url('../assets/bg.png');
  //   background-size: 100%;
  //   background-position: center;
  //   z-index: 0;
  //   // width: 100vw;
  //   // height: 100vh;
  // }
  .container div {
    z-index: 1;
  }
  h1 {
    font-size: 2.2rem;
    line-height: 2.5rem;
    font-weight: 900;
    font-style: itali;
    @include xl {
      font-size: 3rem;
    line-height: 3.2rem;
    }
  }
  .data-evento {
    span {
      background-color: $primary;
      color: #ffffff;
    }
  }
  .curso-info {
    p {
      font-size: .8em;
      margin-bottom: 5px;
      span {}
    }
  }
  ul {
    list-style: none;
    padding-left: 0;
    // li {
    //   background: $primary;
    //   color: #ffffff;
    // }
  }
  .v-expansion-panel-header {
    border-bottom: solid 1px $primary;
  }
  .v-expansion-panel-content {
    background-color: #fbfbfb;
  }
  .palestrantes {
    .avatar {
      border: solid 2px $primary;
      border-radius: 50%;
      transition: all .3s;
    }
    .palestrante {
      margin-bottom: 30px;
      p.p-nome {
        font-weight: bold;
        font-size: 1.1em;
      }
      p.allcaps {
        font-size: .7em;
        font-weight: normal;
      }
      p{
        font-size: .8em;
      }
    }
  }
  #como-funciona {
    border-radius: 20px;
    h2 {
      font-size: 2em;
    }
    // .row:first-child {
    //   border-radius: 20px
    // }
    .vantagens {
      align-content: stretch;
      justify-content: space-around;

      h2 {
        font-size: 3em;
      }
      .vantagem {
        // padding-bottom: 100px;
        .vant {
          flex-direction: column;
          align-items: center;
          height: 100%;
          background-color: #ffffff;
          color: #191919;
          border-radius: 20px;
          h4 {
            font-size: 1.1em;
          }
          p {
            font-size: .9em;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .orgs-img {
    height: 30px;
    @include xs {
      height: 50px;
    }
  }
}
</style>